module.exports = __webpack_public_path__ + "static/img/si.52f4acef.svg";